export { jobSalaryPeriodsSk } from './sk';
export { jobSalaryPeriodsEn } from './en';
export { jobSalaryPeriodsCz } from './cz';

// Helper function to get job salary periods by language
import { jobSalaryPeriodsSk } from './sk';
import { jobSalaryPeriodsEn } from './en';
import { jobSalaryPeriodsCz } from './cz';

export function getJobSalaryPeriods(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return jobSalaryPeriodsSk;
    case 'en':
      return jobSalaryPeriodsEn;
    case 'cz':
      return jobSalaryPeriodsCz;
    default:
      return jobSalaryPeriodsSk; // fallback to Slovak
  }
}
